angular.module('workflow')
    .component('workflowTable', {
        bindings: {
            projectId: '<',
            ids: '<',
            query: '<',
            includeConfidential: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/workflow/table.html',
        controller($scope, $state, Project, ProjectService, Workflow, BusinessThread) {
            this.ProjectService = ProjectService;

            this.$onChanges = () => {
                if (angular.isArray(this.ids) && !this.ids.length) {
                    this.page = {list: [], fullListSize: 0, objectsPerPage: 50, pageNumber: 1}
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                    return
                }

                let params = {
                    mainProject: this.projectId,
                    ids: this.ids,
                    search: this.query
                }
                let resource = this.includeConfidential === true ? BusinessThread.workflowTable : Workflow.allGranted
                if (this.includeConfidential === true) {
                    params.includeConfidential = true
                }
                return resource(params).$promise.then(data => {
                    this.page = data;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                });
            }
        }
    })
